var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSimulados(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "24px",
    viewBox: "0 0 25 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "5D48A792-C606-4720-A56E-08DDDDA4D2D6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01.home-aba/concursos",
    transform: "translate(-24.000000, -574.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu-principal",
    transform: "translate(24.000000, 232.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-simulados",
    transform: "translate(0.000000, 342.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bound",
    fillOpacity: 0,
    fill: "#F5F5F5",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.63810145,4.84735113 C6.80325327,1.14412761 12.0271837,-0.0361504183 16.4769998,1.94657177 C16.9814723,2.17135157 17.208208,2.76252735 16.9834282,3.26699984 C16.7586484,3.77147232 16.1674726,3.99820803 15.6630002,3.77342823 C12.0222415,2.15120099 7.74811661,3.11688301 5.15844694,6.14679316 C2.56877726,9.17670331 2.28046513,13.5490667 4.44985974,16.8927879 C6.61925436,20.2365091 10.7295699,21.7550583 14.5518173,20.6249391 C18.2871955,19.5205044 20.877845,16.1435426 20.9957993,12.2709618 L21,12 L21,11.08 C21,10.5277153 21.4477153,10.08 22,10.08 C22.5128358,10.08 22.9355072,10.4660402 22.9932723,10.9633789 L23,11.08 L23,12.0005718 C22.9972144,16.8721262 19.7905232,21.161606 15.1188875,22.5428628 C10.4472518,23.9241196 5.42353274,22.0681151 2.77205043,17.9813447 C0.120568123,13.8945744 0.472949627,8.55057464 3.63810145,4.84735113 Z",
    id: "Path",
    fill: "#1717CE",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2925399,3.29324668 C21.682869,2.90252728 22.3160339,2.90221085 22.7067533,3.29253993 C23.0674174,3.6528437 23.0954304,4.22006082 22.7906016,4.61250442 L22.7074601,4.70675332 L12.7074601,14.7167533 C12.347029,15.0775448 11.7795698,15.1054329 11.3871346,14.800322 L11.2928932,14.7171068 L8.29289322,11.7171068 C7.90236893,11.3265825 7.90236893,10.6934175 8.29289322,10.3028932 C8.65337718,9.94240926 9.22060824,9.91467972 9.61289944,10.2197046 L9.70710678,10.3028932 L12,12.595 L21.2925399,3.29324668 Z",
    id: "Path",
    fill: "#1717CE",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSimulados);
export default __webpack_public_path__ + "static/media/ic-simulados.8f3d54ad4d2881526b483546d26c6308.svg";
export { ForwardRef as ReactComponent };